// ParkingEvo application version — updated by patch apply scripts
export const APP_VERSION = '1.0.9.62';
